import type { ReportOrganizationStatus } from '@/constants/reportOrganizationStatuses';
import type { PaginatedRequest } from '@/core/api/types';

export type Report = {
  totalRows: number;
  totalSelectedRows: number;
  id: number;
  name: string;
  reportTypePeriodId: number;
  organizationStatusId: number;
  organizationStatusChangedDate: string | null;
  organizationId: number;
  organizationBudgetIdNumber: string;
  organizationTaxIdNumber: string | null;
  organizationCompanyNumber: string | null;
  organizationName: string;
  organizationNameTranslit: string;
  organizationPlace: string | null;
  organizationPlaceTranslit: string | null;
  organizationTreasury: number;
  dateFrom: string;
  dateTo: string;
  createdUserId: number;
  createdDate: string;
  approvedUserId: number | null;
  approvedDate: string | null;
  canceledUserId: number | null;
  canceledDate: string | null;
  modifiedUserId: number | null;
  modifiedDate: string | null;
  status: number;
  description: string | null;
  organizationStatus: string | null;
  maxAllowedReportsPerTypeAndPeriod: number;
  periodFrom: string;
  periodTo: string;
  periodStatus: number;
  automaticProcessingCodeVersionId: number;
  reportTypeId: number;
  reportType: string;
  reportTypeFrequencyId: number;
  reportTypeScheduleVersionId: number;
  organizationGroup: number;
  validationFailedCount: number;
  link: string | null;
  selected: boolean;
};

export type ReportListResponse = {
  reports: Report[];
};

export type ReportActivityType = {
  text: string;
  value: number;
  showDetails: boolean;
};

export type FilterableReportColumns =
  | 'name'
  | 'organizationBudgetIdNumber'
  | 'organizationName'
  | 'organizationGroup'
  | 'reportTypeFrequencyId'
  | 'reportTypePeriodId'
  | 'dateFrom'
  | 'dateTo'
  | 'status';

export type ReportsFilter = Record<`filter[${FilterableReportColumns}]`, string>;
export type GetReportsRequest = PaginatedRequest & Partial<ReportsFilter>;

export enum ReportRouteParam {
  ReportsType = 'reportsType'
}

export type DueDateReport = {
  dueDate: string;
  reportTypeId: number;
  approved: number;
  pending: number;
  dueDateAlert: string;
};

export type ReportDetailsForm = {
  name: string;
  period: string;
  organizationStatus: ReportOrganizationStatus;
  description: string;
  organizationStatusChangedDate: string;
};

export type SelectionData = {
  reportIds: number[];
  reportsPeriodType: ReportsPeriodType;
  reportsType: ReportsType;
};

export enum ReportFilter {
  Selected = 'filter[selected]',
  ReportTypePeriodId = 'filter[reportTypePeriodId]',
  AllReports = 'all-reports',
  OwnReports = 'own-reports'
}

export enum ReportColumn {
  Status = 'status'
}

export enum ReportsPeriodType {
  Active = 'active',
  Historic = 'historic'
}

export enum ReportsType {
  AllReports = 'allReports',
  OwnReports = 'ownReports',
  ChildReports = 'childReports'
}

export enum ReportsTypeRouteParam {
  AllReports = 'all-reports',
  OwnReports = 'own-reports'
}
